import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import moment from 'moment';

import { fetchAnnotation, deleteNote } from 'services/annotations/duck';
import ViewNoteTile from 'components/molecules/annotations/ViewNoteTile';

class AnnotationViewContainer extends Component {
    componentDidMount() {
        this.props.fetchAnnotation({ annotationId: this.props.match.params.id });
    }

    render() {
        const { annotation } = this.props;
        const type = get(annotation, 'type');
        const entityId = get(annotation, 'meta.entityId');
        const firstName = get(annotation, 'meta.user.firstName');
        const lastName = get(annotation, 'meta.user.lastName');
        const startDate = get(annotation, 'meta.start');

        const formattedStartDate = moment.utc(startDate).format('YYYY-MM-DD');

        return type === 'NOTE' ? (
            <React.Fragment>
                {`Created by ${firstName} ${lastName} on ${formattedStartDate}`}
                <ViewNoteTile
                    note={annotation}
                    entityId={entityId}
                    deleteNote={this.props.deleteNote}
                    adminContext={true}
                    fluid />
            </React.Fragment>
        ) : null;
    }
}

const mapStateToProps = state => ({
    annotation: get(state, 'annotations.annotation', {})
});

export default connect(mapStateToProps, {
    fetchAnnotation,
    deleteNote
})(AnnotationViewContainer);



// WEBPACK FOOTER //
// ./src/containers/annotations/AnnotationViewContainer.js